export const pricingData = [
	{
		title: 'Basic',
		price: '$700.99 user/month after offer period',
		numAcc: '50-100 accounts',
		features: ['Secure accounts', 'Best for small business', 'Easy', 'Affordable', '1GB RAM'],
	},
	{
		title: 'Standard',
		price: '$1800.99 user/month after offer period',
		numAcc: '50-500 accounts',
		features: [
			'Secure accounts',
			'Best for small business',
			'Customizable',
			'3GB RAM',
			'1TB SSD',
		],
	},
	{
		title: 'Premium',
		price: '$3200.50 user/month after offer period',
		numAcc: '50-1000 accounts',
		features: [
			'Secure accounts',
			'Best for small business',
			'Customizable',
			'Easy Integration',
			'Development Team',
			'DNS & Domain included',
		],
	},

	{
		title: 'Enterprise',
		price: '$55000.50 user/month after offer period ',
		numAcc: '1000+ Accounts',
		features: ['Unlimited Storage', 'Scalability', 'Free DNS & Domain'],
	},
];
